import { Grid } from "@mui/material";
import React from "react";
import { Link } from "@mui/material";
import { useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";

function GroupOrdersDayMenuFlat(props) {
    const appdata = useSelector(appdataSelector);

    if (!props.menus){
        return
    }

    return (
        <React.Fragment>
            <Grid
                container
                key={"GRID"}
                item
                xs={12}
                sx={{
                    marginBottom: "20px",
                    padding: "10px 10px 10px 10px",
                    border: "2px solid",
                    borderColor: "lightgray"
                }}>
                <Grid item xs={4} sx={{ padding: "0px 10px 0px 10px", borderColor: "lightgray" }}>

                    <div>
                        Cost Center: <b>{props.order.COST_CENTER}</b>
                    </div>

                </Grid>
                <Grid item xs={4} sx={{ padding: "0px 10px 0px 10px", borderRight: "1px solid", borderLeft: "1px solid", borderColor: "lightgray" }}>

                    <div>
                        Project: <b>{props.order.PROJECT}</b>
                    </div>

                </Grid>
                <Grid item xs={4} sx={{ padding: "0px 10px 0px 10px", borderColor: "lightgray" }}>

                    <div>
                        Company or Name: <b>{props.order.COMPANY}</b>
                    </div>

                </Grid>
                <Grid item xs={12} sx={{ padding: "10px 10px 0px 10px", borderTop: "1px solid", marginTop: "10px", borderColor: "lightgray" }}>
                    {Object.keys(props.menus).map(key => {
                        if (key.includes("_NUMB") && parseInt(props.menus[key]) > 0) {
                            let menukey = key.substring(0, 5);
                            return (
                                <div>
                                    [ {props.order[menukey]
                                        ? parseInt(props.order[menukey])
                                        : ""} ]  {
                                        props.mappedMenus[parseInt(props.menus[key])][
                                        "MENU_" + appdata.language
                                        ]
                                    }
                                    {key == "MENU3_NUMB" && appdata.language == "DE" && " + Salat"}
                                    {key == "MENU3_NUMB" && appdata.language == "EN" && " + Salad"}
                                    <Link
                                        key={"Link" + menukey}
                                        component="button"
                                        variant="body2"
                                        className="ml-1"
                                        onClick={() => {
                                            console.log("click allergie");
                                            handleAllergieClick({
                                                allergies:
                                                    props.mappedMenus[parseInt(props.menus[key])][
                                                    "MENU_ALGEN"
                                                    ]
                                            });
                                        }}
                                    >
                                        {
                                            props.mappedMenus[parseInt(props.menus[key])][
                                            "MENU_ALGEN"
                                            ]
                                        }
                                    </Link></div>
                            )
                        }
                    })}
                </Grid>
            </Grid>






        </React.Fragment>
    )
}

export default GroupOrdersDayMenuFlat